// TableToolbar — the strip above a table (inside its Card/panel): a count
// summary on the leading side and optional actions (Columns, etc.) on the
// trailing side. Layout-only; the count renders as a bold number + muted word.

import { type ReactNode } from 'react';

export interface TableToolbarProps {
  /** Item count shown bold on the leading side. */
  count: number;
  /** Word after the count, e.g. "guests" / "people". */
  countLabel: string;
  /** Trailing-side actions (Columns menu, buttons, …). */
  children?: ReactNode;
  className?: string;
}

const TableToolbar = ({ count, countLabel, children, className }: TableToolbarProps) => (
  <div className={`table-toolbar${className ? ` ${className}` : ''}`}>
    <span className='table-toolbar__count'>
      <b>{count}</b> {countLabel}
    </span>
    {children && <div className='table-toolbar__actions'>{children}</div>}
  </div>
);

export default TableToolbar;
